export const ANNOUNCEMENT_BAR_CLOSED_KEY = 'is_announcement_bar_closed_by_user';

export const SELECTORS = {
  CONTAINER: 'js-announcement-bar',
  CLOSE_BTN: 'js-announcement-bar-close'
};
